module.exports = __webpack_public_path__ + "img/crown.3af35db3.svg";